import React from 'react'
import ReactDOM from 'react-dom'
import './global.scss'
import App from './App'
import './config/config-amplify'
import { shouldEnableNewRelic, getNewRelicConfig } from './newrelic/newrelic-config'

// Initialize New Relic Browser Agent
if (shouldEnableNewRelic()) {
  import('@newrelic/browser-agent')
    .then(({ BrowserAgent }) => {
      const config = getNewRelicConfig()
      if (config) {
        new BrowserAgent(config)
      }
    })
    .catch(err => {
      console.warn('Failed to initialize New Relic Browser Agent:', err)
    })
}

ReactDOM.render(<App />, document.getElementById('root'))
